import { cloneElement, FC, MouseEvent, ReactElement } from 'react'
import { AppBar, Toolbar, Tooltip, IconButton, useScrollTrigger, makeStyles } from '@material-ui/core'
import ExitIcon from '@material-ui/icons/ExitToAppOutlined'

import { useSessionContext } from '../contexts'

import { AppRoute } from '../Routes'
import { drawerWidth } from './Main'
import { Breadcrumbs } from '.'

type TopBarProps = {
    crumbs: AppRoute[]
}

const TopBar = (props: TopBarProps) => {
    const classes = useStyles()
    const { user } = useSessionContext()

    return (
        <ElevationScroll {...props}>
            <AppBar position={'fixed'} className={classes.appBar}>
                <Toolbar>
                    <div className={classes.crumbs}>
                        <Breadcrumbs crumbs={props.crumbs} />
                    </div>
                    <Tooltip title={user?.companyName || ''}>
                        <span className={classes.user}>{user?.userName.replace(/,/g, ', ')}</span>
                    </Tooltip>
                    <ExitButton />
                </Toolbar>
            </AppBar>
        </ElevationScroll>
    )
}

export default TopBar

const ExitButton: FC = () => {
    const { user, isLMSAvailable } = useSessionContext()

    if (!isLMSAvailable) return <></>

    const concedeControl = (): void => {
        console.log(`Goodbye ${user?.userName}! Closing window...`)
        if (window?.parent) window.parent.postMessage('ConcedeControl', '*') //FIXME: This needs to use the new ConcedeControl
    }

    const handleExit = (e: MouseEvent) => {
        e.preventDefault()
        concedeControl()
    }

    return (
        <Tooltip title={'Exit Reporting Module to LMS.'}>
            <IconButton onClick={handleExit} color={'primary'}>
                <ExitIcon />
            </IconButton>
        </Tooltip>
    )
}

type ESProps = {
    children: ReactElement
}

const ElevationScroll = (props: ESProps) => {
    const { children } = props

    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0
    })

    return cloneElement(children, {
        elevation: trigger ? 4 : 0,
    })
}

const useStyles = makeStyles(theme => ({
    appBar: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary
    },
    crumbs: {
        flexGrow: 1,
    },
    user: {
        padding: theme.spacing(0, 2)
    },
}))